<template>
    <p class="input-label">Immagine</p>
    <div class="image-uploader">
        <input type="file" accept="image/*" @change="handleFileSelect" class="input-field input-field-upload">
        <i id="camera-icon" class="fa-solid fa-camera" @click="takePhoto"></i>
    </div>
</template>

<script>
import { capturePhoto } from '@/utils/CameraCapture';
import { convertToWebP, generateRandomFileName } from '@/utils/base64ToWebp';

export default {
    emits: ['image-selected'],
    data() {
        return {
            selectedFile: null
        };
    },
    methods: {
        async handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                try {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = async () => {
                        const imageBase64 = reader.result.split(',')[1];
                        const imageWebp = await convertToWebP(imageBase64);
                        const blob = await fetch('data:image/webp;base64,' + imageWebp).then(response => response.blob());
                        const fileName = generateRandomFileName();
                        const optimizedFile = new File([blob], fileName, { type: 'image/webp' });
                        this.selectedFile = optimizedFile;
                        //const imageUrl = URL.createObjectURL(optimizedFile);
                        this.$emit('image-selected', optimizedFile);
                    };
                } catch (error) {
                    console.error('Errore durante la gestione dell\'immagine:', error);
                    alert('Si è verificato un errore durante la gestione dell\'immagine: ' + error.message);
                }
            }
        },
        async takePhoto() {
            try {
                const imageBase64 = await capturePhoto();
                if (imageBase64) {
                    const imageWebp = await convertToWebP(imageBase64);
                    const blob = await fetch('data:image/webp;base64,' + imageWebp).then(response => response.blob());
                    const fileName = generateRandomFileName();
                    const file = new File([blob], fileName, { type: 'image/webp' });
                    this.selectedFile = file;
                    this.$emit('image-selected', this.selectedFile);
                } else {
                    alert('Impossibile catturare l\'immagine.');
                }
            } catch (error) {
                console.error('Errore durante la cattura della foto:', error);
                alert('Errore durante la cattura della foto: ' + error.message);
            }
        }
    }
};
</script>

<style scoped>
.input-label {
    margin-top: 5px;
    margin-bottom: 0px !important;

}

.input-field {
    margin-top: 8px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 6px;
}

.input-field-upload {
    width: 85%;
    position: relative;
}

#camera-icon {
    text-align: center;
    font-size: 30px;
    width: 15%;
    margin: auto;
}

.image-uploader {
    display: flex;
    align-items: flex-end;
}
</style>
